import './App.css';
import TrackApplication from './components/TrackApplication';
import ApplicationStatus from './components/ApplicationStatus';
import { HashRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
function App() {
  return (
    <>
     <Router>
      <Routes>
        <Route path="/" element={<TrackApplication/>} />
        <Route path="/track-application" element={<TrackApplication/>} />
        <Route path="/application-status" element={<ApplicationStatus/>} />
      </Routes>
    </Router>
    </>
  );
}

export default App;
